var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cat-error-placeholder',{staticClass:"page-error h-screen ios-touch-scroll",attrs:{"error-type":"empty","error-text":_vm.errorText}})}
var staticRenderFns = []

export { render, staticRenderFns }